export default "__VITE_ASSET__5f81384d__"